import { apiMutate } from 'service/utils/mutation';

import { useDeliveryZoneMsToken } from 'hooks';
import { GRAPHQL_CLIENT_NAMES } from 'service/constants';
import { UpdateBulkDeliveryZonesInput, UpdateBulkDeliveryZonesPayload } from '../../types/generated';
import { updateBulkDeliveryZoneMutation } from '../../mutations';

type useUpdateBulkDeliveryZoneType = () => ({
  input,
}: {
  input?: UpdateBulkDeliveryZonesInput;
}) => Promise<void | Partial<UpdateBulkDeliveryZonesPayload> | { hasError: boolean }>;

const useUpdateBulkDeliveryZone: useUpdateBulkDeliveryZoneType = () => {
  const deliveryZoneMsToken = useDeliveryZoneMsToken();
  return input =>
    apiMutate({
      mutation: updateBulkDeliveryZoneMutation,
      variables: { input },
      clientName: GRAPHQL_CLIENT_NAMES.DELIVERY_ZONES,
      requestHeaders: { token: deliveryZoneMsToken },
      handler: (res: any) => res,
    });
};

export default useUpdateBulkDeliveryZone;
